import { tint, shade } from 'polished';
import { LightTint, DarkTint } from './theme.types';

export const lights: (c: string) => LightTint = (colour) => ({
  light1: tint(0.2, colour),
  light2: tint(0.4, colour),
  light3: tint(0.6, colour),
});

export const darks: (c: string) => DarkTint = (colour) => ({
  dark3: shade(0.6, colour),
  dark2: shade(0.4, colour),
  dark1: shade(0.2, colour),
});
